import React from "react";
import { Form } from "react-final-form";
import { FORM_ERROR } from "final-form";
import createDecorator from "final-form-focus";
import { injectIntl, FormattedMessage } from "react-intl";
import { compose } from "redux";
import { connect } from "react-redux";
import { Button } from "@ebsco-ui/ebsco-ui";
import sharedMessages from "../../../../../shared-messages";
import mapApiErrorsToFormErrors from "../../../../utils/map-api-errors-to-field-errors";
import submitErrorFieldsHaveChanged from "../../../../utils/submit-error-fields-have-changed";
import {
  submitVerificationDataRequest,
  submitVerificationDataSuccess,
  submitVerificationDataFailure,
  getUsername,
  getSecretQuestionCode
} from "../../../../store/password/reset";
import FormErrorNotification from "../../../form-error-notification";
import SecretQuestionAnswer from "../../../secret-question-answer";
import { useEdgeApiContext } from "../../../edge-api";
import RecoveryControls from "../recovery-controls";
import messages from "./enter-secret-question-answer-form-messages";
import submitMessages from "./submit-error-message-descriptors";

import "./enter-secret-question-answer-form.scss";

const focusOnErrors = createDecorator();

const block = "enter-secret-question-answer-form";

const EnterSecretQuestionAnswerForm = ({
  intl: { formatMessage },
  secretQuestionCode,
  submtVerificationDataRequest,
  submtVerificationDataSuccess,
  submtVerificationDataFailure,
  username
}) => {
  const personalUserApi = useEdgeApiContext();

  const onSubmit = async ({ secretQuestionAnswer }) => {
    try {
      submtVerificationDataRequest();

      await personalUserApi.postVerifySecretQuestionAnswer(
        secretQuestionAnswer,
        username
      );
      submtVerificationDataSuccess(secretQuestionAnswer);
    } catch (error) {
      submtVerificationDataFailure(error);
      let formErrors = {
        [FORM_ERROR]: {
          headerMessage: formatMessage(sharedMessages.somethingWentWrong),
          descriptionMessage: formatMessage(messages.unableToVerifyAnswer)
        }
      };

      if (error.response) {
        const {
          response: { status, data }
        } = error;

        switch (status) {
          case 400:
            const mappedErrors = mapApiErrorsToFormErrors(data.details, key => {
              return submitMessages[key]
                ? formatMessage(submitMessages[key])
                : undefined;
            });
            if (Object.keys(mappedErrors).length) {
              formErrors = mappedErrors;
            }
            break;
          case 429:
            formErrors = {
              [FORM_ERROR]: {
                headerMessage: formatMessage(sharedMessages.somethingWentWrong),
                descriptionMessage: formatMessage(
                  sharedMessages.exceededAllowedRequestAttempts
                )
              }
            };
            break;
          default:
            return formErrors;
        }
      }

      return formErrors;
    }
  };

  return (
    <div className={block}>
      <Form onSubmit={onSubmit} decorators={[focusOnErrors]}>
        {({
          handleSubmit,
          submitting,
          submitFailed,
          submitErrors,
          submitError,
          dirtyFieldsSinceLastSubmit,
          dirty
        }) => {
          const disableSave =
            submitting ||
            !(submitFailed
              ? submitErrorFieldsHaveChanged(
                  submitErrors,
                  dirtyFieldsSinceLastSubmit
                )
              : dirty);

          return (
            <form onSubmit={handleSubmit}>
              {submitError && <FormErrorNotification {...submitError} />}
              <h2 className="prompt">
                <FormattedMessage {...messages.prompt} />
              </h2>
              <SecretQuestionAnswer secretQuestionCode={secretQuestionCode} />
              <RecoveryControls />
              <Button
                className="continue-button"
                type="submit"
                disabled={disableSave}
                styleType="solid"
              >
                <FormattedMessage {...sharedMessages.continue} />
              </Button>
            </form>
          );
        }}
      </Form>
    </div>
  );
};

const mapStateToProps = state => ({
  username: getUsername(state),
  secretQuestionCode: getSecretQuestionCode(state)
});

const mapDispatchToProps = {
  submtVerificationDataRequest: submitVerificationDataRequest,
  submtVerificationDataSuccess: submitVerificationDataSuccess,
  submtVerificationDataFailure: submitVerificationDataFailure
};

export { EnterSecretQuestionAnswerForm };
export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(EnterSecretQuestionAnswerForm);
